import {
  AbsoluteFill,
  interpolate,
  Sequence,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from 'remotion';

export type PromptStudioScene = {
  title: string;
  subtitle?: string;
  durationInFrames: number;
  bgFrom: string;
  bgTo: string;
};

export type PromptStudioCompositionProps = {
  fps: number;
  scenes: PromptStudioScene[];
};

export function getPromptStudioDurationInFrames(props: PromptStudioCompositionProps): number {
  return props.scenes.reduce((acc, s) => acc + Math.max(1, s.durationInFrames), 0);
}

function SceneCard({ scene }: { scene: PromptStudioScene }) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const titleY = spring({
    frame,
    fps,
    config: { damping: 18 },
  });

  const opacity = interpolate(frame, [0, 12], [0, 1], { extrapolateRight: 'clamp' });

  return (
    <AbsoluteFill
      style={{
        background: `linear-gradient(135deg, ${scene.bgFrom} 0%, ${scene.bgTo} 100%)`,
        justifyContent: 'center',
        alignItems: 'center',
        padding: 64,
      }}
    >
      <div
        style={{
          transform: `translateY(${(1 - titleY) * 40}px)`,
          opacity,
          textAlign: 'center',
          maxWidth: 920,
        }}
      >
        <h1
          style={{
            color: '#fff',
            fontSize: 72,
            fontWeight: 700,
            lineHeight: 1.08,
            margin: 0,
            textShadow: '0 4px 32px rgba(0,0,0,0.35)',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          {scene.title}
        </h1>
        {scene.subtitle ? (
          <p
            style={{
              color: 'rgba(255,255,255,0.92)',
              fontSize: 36,
              marginTop: 28,
              lineHeight: 1.35,
              fontWeight: 500,
              textShadow: '0 2px 20px rgba(0,0,0,0.3)',
              fontFamily: 'system-ui, sans-serif',
            }}
          >
            {scene.subtitle}
          </p>
        ) : null}
      </div>
    </AbsoluteFill>
  );
}

export function PromptStudioComposition(props: PromptStudioCompositionProps) {
  let from = 0;
  return (
    <>
      {props.scenes.map((scene, i) => {
        const dur = Math.max(1, scene.durationInFrames);
        const el = (
          <Sequence key={i} from={from} durationInFrames={dur}>
            <SceneCard scene={scene} />
          </Sequence>
        );
        from += dur;
        return el;
      })}
    </>
  );
}
